/* eslint import/no-extraneous-dependencies: 0 */

import 'bootstrap';

import { handleResponseErrors } from 'utils/messages';
import { setTimeout } from 'utils/wrappers';

export const DISPLAY_ERR_INTERVAL = 300;

export function displayErrorOnField(formField, message) {
  formField.addClass('error');
  formField.popover({
    html: true,
    template: '<div class="popover popover-error"><div class="arrow"></div><div class="popover-inner"><div class="popover-body"></div></div></div>',
    content: message,
    placement: 'bottom',
    trigger: 'manual',
    delay: 0,
  }).popover('show');
}

export function displayErrorsOnView(view, response, attributes) {
  handleResponseErrors(response, errors => {
    let delay = 0;
    let focusSet = false;

    attributes.forEach(attribute => {
      const error = errors.find(errorItem => errorItem.field === attribute);

      if (error) {
        if (!focusSet) {
          view.setFocus(attribute);
          focusSet = true;
        }

        setTimeout(() => {
          view.displayError(attribute, error.message);
        }, delay);
        delay += DISPLAY_ERR_INTERVAL;
      }
    });
  });
}

export function clearPopoversOnView(view) {
  view.$('input').popover('hide');
}



// WEBPACK FOOTER //
// ./utils/forms.js